import App from './App.vue'
import axios from 'axios'
import router from './router'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueBarcode from 'vue-barcode'
import VueQRCodeComponent from 'vue-qrcode-component'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.use(VueAxios, axios);
Vue.component('barcode', VueBarcode)
Vue.component('qr-code', VueQRCodeComponent)

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
